// extracted by mini-css-extract-plugin
export default {"historySection":"HistorySection_historySection__x7Ape"};